import React, { useContext, useEffect, useState } from 'react';
import Homecontainer from '../container/Homecontainer';
import Layout from '../components/Layout/Layout';

import ProductLayout from '../components/Layout/ProductLayout';
import Registercontainer from '../container/Registercontainer';
import MemberLayout from '../components/Layout/MemberLayout';
import { UserContext } from '../context/Users';

const MemberRegisterpage = () => {
  const { user, dispatch2 } = useContext(UserContext);

  

  return (
    <MemberLayout>
      <Registercontainer/>
    </MemberLayout>

  );
}

export default MemberRegisterpage;
